import React from 'react';

import {
  FilterButton,
  List,
  TopToolbar,
} from 'react-admin';

import {
  Box,
  Card,
} from '@mui/material';

import Pagination from '../../../../layout/Pagination';

import { entityListMap } from '../../../../../constants/entityFeatures';
import entityTypes from '../../../../../constants/entityTypes';
import PrefillButton from '../../../utils/PrefillButton';
import { prefillPartyGetter } from './forms';
import { getIndividualFilters } from '../../../../individual/IndividualList';
import { getBusinessFilters } from '../../../../business/BusinessList';

const LIST_FILTERS = {
  [entityTypes.INDIVIDUAL]: getIndividualFilters,
  [entityTypes.BUSINESS]: getBusinessFilters,
} as const;

const Entities = ({
  type,
  handleOpenChange,
  entities,
}: {
  type: typeof entityTypes.INDIVIDUAL | typeof entityTypes.BUSINESS;
  handleOpenChange: () => void;
  entities?: string[];
}) => {
  const EntityListBody = entityListMap[type];
  if (!EntityListBody) return null;

  return (
    <List
      filter={{
        id: entities,
      }}
      perPage={10}
      filters={LIST_FILTERS[type]({
        hideSearch: !!entities,
      })}
      pagination={<Pagination disableEmptyText />}
      resource={type === entityTypes.INDIVIDUAL ? 'individuals' : 'businesses'}
      actions={(
        <TopToolbar>
          <FilterButton />
        </TopToolbar>
      )}
      empty={false}
      component={Box}
      disableSyncWithLocation
      storeKey={false}
      sort={{ field: 'createdAt', order: 'DESC' }}
    >
      <Card variant="outlined">
        <EntityListBody>
          <PrefillButton
            handleOpenChange={handleOpenChange}
            prefillForm={prefillPartyGetter(type)}
          />
        </EntityListBody>
      </Card>
    </List>
  );
};

export default Entities;
